import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/layout/SiteHeader";
import { ShieldCheck } from "lucide-react";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-[#F3F4F6]">
      <div className="mx-auto grid min-h-[calc(100vh-4rem)] w-full max-w-6xl gap-0 px-5 py-10 sm:px-8 lg:grid-cols-2 lg:items-center">
        <div className="hidden lg:block">
          <Logo />
          <h2 className="mt-8 max-w-md font-heading text-3xl font-extrabold leading-tight tracking-tight text-ff-blue">
            Fast for donors. Strict for fundraisers. Controlled before payout.
          </h2>
          <p className="mt-4 max-w-md text-ff-dark">
            Join the U.S.-only crowdfunding platform built on trust. It's free to start a fundraiser.
          </p>
          <div className="mt-8 flex items-center gap-3 rounded-xl border border-ff-border bg-white p-4">
            <ShieldCheck className="h-6 w-6 text-ff-green" />
            <span className="text-sm text-ff-dark">Campaigns and payout requests are reviewed before funds are released.</span>
          </div>
        </div>

        <div className="mx-auto w-full max-w-md rounded-2xl border border-ff-border bg-white p-8 shadow-sm">
          <div className="mb-6 lg:hidden"><Logo /></div>
          <h1 className="font-heading text-2xl font-bold tracking-tight text-ff-blue">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-ff-dark">{subtitle}</p>}
          <div className="mt-6">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-ff-dark">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
